import React, { useRef, useState, useEffect } from 'react'
import qs from 'qs'
import { message as mes } from 'meinian-package/src/utils'
import useIntersectionObserver from 'meinian-package/src/common/hooks/useIntersectionObserver'
import { Card, BatchAll, BatchNum, BatchOptions, BatchStop, BatchStart, ClearFilter } from 'component'
import { BaseFilter } from 'component/filter'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { convertParams, generateParamsLength } from 'component/util'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../../components/header/customizeHeader'
import './index.less'

export default function Index() {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const defaultParams = {
    qualityFlag: 0,
    duplicateFilter: 0,
    subscribeType: 0,
  }
  const [params, setParams] = useState(query.params || {})
  const [isBatch, setIsBatch] = useState(false)
  const [batchAll, setBatchAll] = useState([])
  const [total, setTotal] = useState(0)
  const $masonry = useRef()
  const $screen = useRef()

  const entry = useIntersectionObserver($screen, {})

  useEffect(() => {
    const sub = () => $masonry.current?.init()
    mes.sub('onMNUploadImage', sub)
    return () => { mes.remove('onMNUploadImage', sub) }
  }, [])

  useEffect(() => {
    if (!$screen.current || !entry) return
    if (entry.isIntersecting) {
      $screen.current.className = 'screen-wrap'
    } else {
      $screen.current.className = 'screen-wrap fixed'
    }
  }, [entry])

  return <>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '智能分类',
          path: '/home/category-tags'
        },
        {
          name: query.tagName,
          path: null
        }
        ]}
      />}
    />
    <div className="meinian-detail-tag">
      <div className="meinian-detail-tag-header">
        <div className="meinian-detail-tag-header-text">{query.tagName}</div>
        <span className="total">{total}</span>
      </div>
      <div className="screen-wrap" ref={$screen}>
        {isBatch ? <div>
          <div className="meinian-space" />
          <BatchAll style={{ marginRight: 16 }} keyValues={batchAll.map(m => `${m.imageGroupEntityId},${m.inspirationId}`)} infos={batchAll} />
          <BatchNum style={{ marginRight: 40 }} />
          <BatchOptions.Collect data={batchAll} onChange={() => { setIsBatch(false); $masonry.current?.init() }} />
          <BatchOptions.Download fileName="全部采集" onChange={() => { setIsBatch(false) }} />
          <BatchOptions.Export fileName="全部采集" onChange={() => { setIsBatch(false) }} />
          <BatchStop onClick={() => setIsBatch(false)} />
        </div> : <div>
          <BaseFilter value={params} onChange={setParams} filterProps={{ requiredTag: [Number(query.tagId)], hiddenNoTag: true }} />
          <div className="meinian-space" />
          {generateParamsLength(params) ? <ClearFilter onChange={() => setParams({})} /> : null}
          <BatchStart onClick={() => setIsBatch(true)} />
        </div>}
      </div>
      <div style={{ padding: '8px 24px 24px 24px' }}>
        <MNWaterfallApi
          idKey={['imageGroupEntityId', 'inspirationId']}
          renderItem={Card.Image}
          cardProps={{ isBatch, showMoveImage: true, allStyleFlag: true }} // allStyleFlag 区别于灵感集的硬编码
          url="/zhikuan/image-bus/inspiration/list-blog"
          method="spost"
          params={{
            ...defaultParams,
            ...convertParams(params),
            tagIdList: [query.tagId, ...(convertParams(params).tagIdList || [])]
          }}
          onTotal={val => setTotal(val)}
          ref={$masonry}
          afterLoad={data => setBatchAll(data)}
          emptyText="该标签下暂无相关图片"
        />
      </div>
    </div>
  </>
}
